<ion-content class="bg-color ion-content add-category">
    <div class="com-content">
      <div class="content-breadcrumb">
        <ul class="breadcrumb">
          <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
            <a routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </li>
        </ul>
      </div>
      <div class="content-grid">
        <div class="m-content">
          <mat-card>
            <mat-card-title class="mc-title">
              <span class="org-header">Database Environment</span>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <form [formGroup]="addDatabaseForm" (ngSubmit)="onSubmit()">
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Storage Name</mat-label>
                      <input type="text" formControlName="storage_name" matInput placeholder="Storage Name" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>DB Version</mat-label>
                      <input type="text" formControlName="dbversion" matInput placeholder="DB Version" required>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>JDBC Driver</mat-label>
                      <input type="text" formControlName="jdbc_driver" matInput placeholder="JDBC Driver" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>JDBC String</mat-label>
                      <input type="text" formControlName="jdbc_string" matInput placeholder="JDBC String" required>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Jar File Name</mat-label>
                      <input type="text" formControlName="jar_file_name" matInput placeholder="Jar File Name" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Jar File API</mat-label>
                      <input type="text" formControlName="jar_file_name_api" matInput placeholder="Jar File API" required>
                    </mat-form-field>
                  </div>
                  <div class="btn-signup-grid">
                    <button mat-raised-button class="btn" routerLink="/baseapp/database-env">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-signup">Add</button>
                  </div>
                </form>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
  
        <app-about-page *ngIf="hide1200"></app-about-page>
      </div>
      <app-footer></app-footer>
    </div>
  </ion-content>
  